<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc?: string,
    features: {
        title: string,
        desc: string,
        icon: string
    }[],
}>();
</script>

<template>
    <SectionsBase class="section relative">
        <div class="mb-3.5 lg:mb-14 lg:mt-10">
            <h2>{{ props.title }}</h2>
            <p 
                v-if="props.desc" 
                class="text-body2-bold text-gray-500 text-center max-w-200 mx-auto"
            >
                {{ props.desc }}
            </p>
        </div>
        <div class="grid-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-10">
            <CardsOld
                v-for="item, index in props.features"
                :key="item.title"
                :item="item"
                class="mx-auto"
                data-aos="fade-up"
                data-aos-duration="1000"
                :data-aos-delay="index % 3 * 300"
            />
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.section::before {
    @apply
    content-[''] absolute w-screen h-full bg-linear-to-b from-[#EEF5FF] via-transparent
    to-transparent top-0 left-1/2 -translate-x-1/2 z-[-1]
}
.section::after {
    @apply
    content-[''] absolute w-screen h-full bg-[url('/img/square-bg-2.webp')] bg-size-[1200px_auto] top-0 
    left-1/2 -translate-x-1/2 z-[-2]
}
</style>